import React, { Component } from 'react';
import { NavLink } from 'react-router-dom'

import '../../css/Selector.css';

class Selector extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {

    let elements = this.props.elements

    elements = elements.map((element) => {
      return <li key={element.title}><NavLink activeClassName="active" to={element.url}>{element.title}</NavLink></li>;
    });

    return (
 
      <div className="selector">

        <ul>

          {elements}

        </ul>

      </div>
              
    );

  }
}

export default Selector;



// WEBPACK FOOTER //
// ./src/js/components/Selector.jsx